import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Download } from "lucide-react";

export default function EmployeePayslips() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/salary/payments").then((r) => setItems(r.data)); }, []);

  const download = (id) => {
    const token = localStorage.getItem("ems_token");
    window.open(`${process.env.REACT_APP_BACKEND_URL}/api/payslip/${id}?auth=${token}`, "_blank");
  };

  const badge = (s) => ({
    processing: "bg-amber-50 text-amber-700 border-amber-300",
    paid: "bg-emerald-50 text-emerald-700 border-emerald-300",
  }[s] || "bg-zinc-100 dark:bg-zinc-800");

  return (
    <div className="space-y-6" data-testid="employee-payslips-page">
      <div>
        <div className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-indigo-600 mb-2">04 / Slips</div>
        <h1 className="rule-text text-3xl sm:text-4xl text-zinc-900 dark:text-zinc-100">Payslips.</h1>
      </div>
      <div className="bg-white dark:bg-zinc-900 border border-zinc-100 dark:border-zinc-800 rounded-xl shadow-sm overflow-x-auto">
          <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Period</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Base</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Reimb</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Bonus</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Ded</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Total</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 dark:text-zinc-500">Status</TableHead>
              <TableHead className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-zinc-400 text-right">Download</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={8} className="text-center py-12 text-zinc-500 dark:text-zinc-400 text-sm">No payslips yet. Admin will process your salary.</TableCell></TableRow>
            ) : items.map((p) => (
              <TableRow key={p.id} data-testid={`payslip-row-${p.id}`}>
                <TableCell className="font-mono">{String(p.month).padStart(2,"0")}/{p.year}</TableCell>
                <TableCell className="font-mono">₹ {p.base_salary.toFixed(2)}</TableCell>
                <TableCell className="font-mono">₹ {p.reimbursement_total.toFixed(2)}</TableCell>
                <TableCell className="font-mono">₹ {p.bonus.toFixed(2)}</TableCell>
                <TableCell className="font-mono">₹ {p.deduction.toFixed(2)}</TableCell>
                <TableCell className="font-mono font-bold">₹ {p.total.toFixed(2)}</TableCell>
                <TableCell><span className={`eyebrow px-2 py-1 border ${badge(p.status)}`}>{p.status}</span></TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="ghost" className="rounded-xl h-8 uppercase tracking-[0.18em] text-xs font-bold" onClick={() => download(p.id)} data-testid={`download-${p.id}`}>
                    <Download size={12} className="mr-1" /> PDF
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
